const Reflux = require('@muzzylane/reflux');
const _ = {
    isEmpty: require('lodash/isEmpty'),
//    isObject: require('lodash/isObject'),
};

const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const AssetUtil = require('../util/asset');
const Globals = require('../../../app/globals');

const RSDActions = Reflux.createActions({
    getRSDServices: { children: ['completed', 'failed'] },
    addRSDService: { children: ['completed', 'failed'] },
    updateRSDService: { children: ['completed', 'failed'] },
    getOrgServiceRSDs: { children: ['completed', 'failed'] },
    addRSD: { children: ['completed', 'failed'] },
    updateRSD: { children: ['completed', 'failed'] },
    getChannelRSDServices: { children: ['completed', 'failed'] },
    getNameAndDescription: { children: ['completed', 'failed'] },
    findMatchingServices: { children: ['completed', 'failed'] },
    getChannelServiceRSDs: { children: ['completed', 'failed'] },
    batchLookup: { children: ['completed', 'failed'] },
});

// Gets organization rsd services
RSDActions.getRSDServices.listen(function(actionId,orgId) {
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/rsd_services`, 'GET')
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});

// Add rsd service
RSDActions.addRSDService.listen(function(actionId, params) {
    const orgId = params.org_user_id;
    var details = {};
    var missingParams = false;
    if (!params.name || !params.service_type) {
        missingParams = true;
    }
    switch(params.service_type) {
        case Globals.RSD_SERVICE_TYPES.OpenRSD:
            details = {
                rsd_id_prefix: params.details.rsd_id_prefix,
                base_api: params.details.base_api,
                api_suffix: (params.details.api_suffix || '')
            };
            if (!details.rsd_id_prefix || !details.base_api) {
                missingParams = true;
            }
            break;
        default:
            break;
    }
    var validParams = {
        name: params.name,
        service_type: params.service_type,
        details: details
    };

    if (!orgId || missingParams ) {
        this.failed(actionId, JSON.stringify(validParams), new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/rsd_service`, 'POST', JSON.stringify(validParams))
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});

RSDActions.getOrgServiceRSDs.listen(function(actionId, params) {
    let {orgId, rsd_service_id} = params;
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/rsd_service/${rsd_service_id}/rsds`, 'GET')
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});


// Update rsd service
RSDActions.updateRSDService.listen(function(actionId, params) {
    let orgId = params.org_user_id;
    let validParams = {
    };
    if (params.name) {
        validParams.name = params.name;
    }
    if (params.details && !_.isEmpty(params.details)) {
        validParams.details = {
            rsd_id_prefix: params.details.rsd_id_prefix,
            rsd_id_suffix: params.details.rsd_id_suffix || '',
            base_api: params.details.base_api,
            api_suffix: params.details.api_suffix || '',
        };
    }

    if (_.isEmpty(validParams)) {
        this.failed(actionId, JSON.stringify(validParams), new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/rsd_service/${params.id}`, 'PUT', JSON.stringify(validParams))
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});

// add rsd 
RSDActions.addRSD.listen(function(actionId, params) {
    const { orgId, rsd_service_id, name, description } = params;
    
    if (!orgId || !rsd_service_id || !name ) {
        this.failed(actionId, JSON.stringify(params), new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    let rsd = { 
        name, 
        description 
    };
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/rsd_service/${rsd_service_id}/add_rsd`, 'POST', JSON.stringify(rsd))
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});


// Update rsd 
RSDActions.updateRSD.listen(function(actionId, params) {
    const { orgId, rsd_service_id, rsd_id, name, description } = params;
    let changes = { name, description };
    
    if (!orgId || !rsd_service_id || !rsd_id || !(name || description) ) {
        this.failed(actionId, JSON.stringify(params), new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/rsd_service/${rsd_service_id}/rsd/${encodeURIComponent(rsd_id)}`, 'PUT', JSON.stringify(changes))
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});


RSDActions.getChannelRSDServices.listen(function(actionId, params) {
    if (!params.channelId) {
        console.log("getChannelRSDServices params missing channelId"); // FIXME: remove debug spam
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/channel/${params.channelId}/rsd_services`, 'GET')
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});


RSDActions.getNameAndDescription.listen(function(actionId, params) {
    const rsd_service_id = params.rsd_service_id;
    const rsd_id = params.rsd_id;
    ServerRequest.makeRequest(`/authoring/get_rsd_name_and_description?service_id=${rsd_service_id}&rsd_id=${encodeURIComponent(rsd_id)}`, 'GET')
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});

RSDActions.findMatchingServices.listen(function(actionId, params) {
    if (!params.channelId || !params.rsd_ids) {
        this.failed(actionId, params, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    let validParams = {
        rsd_ids: params.rsd_ids
    };
    ServerRequest.makeRequest(`/authoring/channel/${params.channelId}/matching_rsd_services`, 'POST', JSON.stringify(validParams))
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});

RSDActions.getChannelServiceRSDs.listen(function(actionId, params) {
    if (!params.channelId || !params.rsd_service_id) {
        console.log("getChannelRSDServices params missing channelId and/or rsd_service_id"); // FIXME: remove debug spam
        this.failed(actionId, params, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    ServerRequest.makeRequest(`/authoring/channel/${params.channelId}/rsd_service/${params.rsd_service_id}/rsds`, 'GET')
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});

RSDActions.batchLookup.listen(function(actionId, params) {
    if (!params.channelId || !params.rsd_queries) {
        console.log("batchLookup params missing channelId and/or rsd_queries"); // FIXME: remove debug spam
        this.failed(actionId, params, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    ServerRequest.makeRequest(`/authoring/channel/${params.channelId}/rsd_batch_lookup`, 'POST', JSON.stringify(params.rsd_queries))
        .then(res => this.completed(actionId, params, res))
        .catch(err => this.failed(actionId, params, err));
});

module.exports = RSDActions;